/** During build process, the current version will be injected here */
export const VERSION = typeof '15.1.0' !== 'undefined' ? '15.1.0' : 'unknown';
